import * as React from "react";

import { selectProject } from "@editor/reducers/core-reducer";
import { trpc } from "@editor/utils/trpc";

import { skipToken } from "@tanstack/react-query";

import { useEditorSelector } from "../../store";

// NOTE (Bobby, 2025-04-24): This component is used to load fonts into the editor based
// on the fonts data from the database. We basically just create a link element for each
// font and append it to the head. We need to remove any existing font elements before
// because you may be moving from a project that has a certain font to another that doesn't
export function CustomFontLoader() {
  const project = useEditorSelector(selectProject);
  const { data: fonts = [] } = trpc.font.getFonts.useQuery(
    project?.id ? { projectId: project?.id } : skipToken,
  );

  React.useEffect(() => {
    // Remove any existing font elements
    const existingFontElements =
      document.head.querySelectorAll("[data-custom-font]");
    existingFontElements.forEach((element) => element.remove());

    fonts.forEach((font) => {
      if (font.type === "google") {
        // Add Google font
        const linkElement = document.createElement("link");
        linkElement.dataset.customFont = font.id;
        linkElement.rel = "stylesheet";
        linkElement.href = font.url;
        document.head.append(linkElement);
      } else if (font.type === "custom") {
        // Determine font format
        let format = null;
        if (font.url.toLowerCase().match(/\.woff2($|\?|#)/)) {
          format = "woff2";
        } else if (font.url.toLowerCase().match(/\.woff($|\?|#)/)) {
          format = "woff";
        } else if (font.url.toLowerCase().match(/\.ttf($|\?|#)/)) {
          format = "truetype";
        } else if (font.url.toLowerCase().match(/\.otf($|\?|#)/)) {
          format = "opentype";
        }

        if (!format) {
          console.warn("Unsupported font format:", font.url);
          return;
        }

        const linkElement = document.createElement("link");
        linkElement.dataset.customFont = font.id;
        linkElement.rel = "preload";
        linkElement.href = font.url;
        linkElement.as = "font";
        linkElement.type = `font/${format}`;
        linkElement.crossOrigin = "anonymous";
        document.head.append(linkElement);

        const styleElement = document.createElement("style");
        styleElement.dataset.customFont = font.id;
        styleElement.textContent = `
          @font-face {
            font-family: "${font.name}";
            src: url('${font.url}') format('${format}');
            font-display: swap;
            font-weight: ${font.weight};
            font-style: ${font.style};
          }
        `;

        document.head.append(styleElement);
      }
    });

    // Cleanup on unmount
    return () => {
      const elements = document.head.querySelectorAll("[data-custom-font]");
      elements.forEach((element) => element.remove());
    };
  }, [fonts]);

  return null;
}
